// store.ts

import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer, { RootState } from './rootReducer'
import { reduxApi } from './slices/apiSlice'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['formNodes', 'expressionBuilder', 'processEdit', 'api'], // Exclude slices from persistence
}

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(reduxApi.middleware),
})
const persistor = persistStore(store)

export { persistor, store }
export type AppDispatch = typeof store.dispatch
